import { createSlice } from "@reduxjs/toolkit";

export const voiceAssistantSlice = createSlice({
    name: "voiceAssistant",
    initialState: {
        isOn: false,
        caption: [],
        activeId: null,
    },
    reducers: {
        setIsOn: (state, action) => {
            state.isOn = action.payload;
        },
        // Begin a new streaming turn (created lazily when first partial arrives)
        _startCaptionTurn: (state, action) => {
            const id = action.payload; // string id
            state.activeId = id;
            state.caption.push({ id, text: "", done: false });
        },

        // Append a partial chunk to the active turn (creates turn if needed)
        appendCaptionPartial: (state, action) => {
            const chunk = action.payload || "";
            if (!state.activeId) {
                const id = Math.random().toString(36).slice(2, 10);
                state.activeId = id;
                state.caption.push({ id, text: chunk, done: false });
            } else {
                const last = state.caption[state.caption.length - 1];
                if (last && last.id === state.activeId) {
                    last.text += chunk;
                } else {
                    // safety: if activeId doesn’t match, start a new one
                    const id = state.activeId;
                    state.caption.push({ id, text: chunk, done: false });
                }
            }
        },

        // Finalize the active turn (called on turn_complete or interrupted)
        endCaptionTurn: (state) => {
            if (!state.activeId) return;
            const last = state.caption[state.caption.length - 1];
            if (last && last.id === state.activeId) {
                last.done = true;
            }
            state.activeId = null;
        },

        // Clear everything (optional utility)
        clearCaptions: (state) => {
            state.caption = [];
            state.activeId = null;
        },

        // Your existing setter (still here if you need to replace array wholesale)
        setCaption: (state, action) => {
            state.caption = action.payload;
            state.activeId = null;
        },
    },
});

export const {
    setIsOn,
    _startCaptionTurn,
    appendCaptionPartial,
    endCaptionTurn,
    clearCaptions,
    setCaption,
} = voiceAssistantSlice.actions;

export default voiceAssistantSlice.reducer;
